var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup158(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7012,
    cy: 9.79562,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9546,
    cy: 6.37717,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0952,
    cy: 1.00461,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3647,
    cy: 41.0525,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5483,
    cy: 48.8669,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.0561,
    cy: 39.0988,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.2392,
    cy: 35.1916,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1694,
    cy: 42.029,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7012,
    cy: 43.9826,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3769,
    cy: 49.8435,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4199,
    cy: 47.8899,
    rx: 0.929677,
    ry: 0.976775,
    fill: "#006D77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7652 33.9787C24.7792 32.3362 24.1382 31.2849 24.1382 31.2849V20.052H12.982V31.2849L1.5935 51.7972C0.114592 54.8681 1.36115 59.6114 5.31221 59.8556H31.5756C33.0877 59.7646 34.3755 59.261 35.2592 58.3904M25.7652 33.9787C26.767 29.6538 30.3857 25.8858 34.1323 23.9591V14.4355H48.5423V23.9591C57.6066 27.3778 66.671 46.6691 48.5423 58.3904C43.9266 60.409 38.9822 60.733 35.2592 58.3904M25.7652 33.9787C26.307 34.8812 26.953 35.9623 27.6541 37.1456M35.2592 58.3904C36.2325 57.4316 36.4565 55.4601 36.4565 55.4601M36.4565 55.4601C36.4565 55.4601 36.1353 52.6755 35.7591 51.7972C34.508 48.8761 30.5962 42.1112 27.6541 37.1456M36.4565 55.4601C36.4565 55.4601 39.5546 55.8555 42.0345 55.9485C56.9094 54.2391 58.5083 36.9014 50.8665 30.7965H32.0405C29.8747 31.9335 27.857 35.192 27.6541 37.1456M13.2145 38.3665H23.9058L31.8081 52.5298C32.606 54.0796 32.7378 55.9485 31.1108 55.9485C31.1108 55.9485 8.33374 55.9485 6.47439 55.9485C4.61504 55.9485 4.1502 54.4833 4.84746 53.2624L13.2145 38.3665Z",
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.2515,
    y: 8.354,
    width: 22.1716,
    height: 5.32581,
    rx: 2.66291,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 15.1909,
    width: 18.9177,
    height: 3.86065,
    rx: 1.93033,
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup158);
export default __webpack_public_path__ + "static/media/Group 158.9a2d4a412f178cfe4a08de34b33119ed.svg";
export { ForwardRef as ReactComponent };